import { Image, Link } from "@customTypes/index";
import { Badge } from "antd";
import { decode } from "html-entities";


interface CoverCtaProps {
	className: string | null;
	name: string | null;
	link: Link | null;
	image: Image | null;
	color: string | null;
	hasNewPosts: boolean;
}

const defaultProps: CoverCtaProps = {
	className: "",
	name: null,
	hasNewPosts: false,
	link: null,
	image: null,
	color: null,
};

const cta = ({ className, name, link, image, color }) => {

	return (
		<a
			className={`covr-cta-cover ${color ? 'shade' : ''}`}
			href={link.url}
			style={{
				backgroundColor: color,
				background: `radial-gradient(circle, ${color} 34%, rgba(2,0,36,1) 170%)`,
			}}
		>
			{name && <h3>{decode(name)}</h3>}
			{image.src && <img
				className={className}
				style={{
					objectPosition: `${image?.focalPoint?.left}% ${image?.focalPoint?.top}%`
				}}
				src={image.src}
				alt={image.alt}
				loading="lazy"
			/>}
		</a >
	)
};

const BgCoverCta = ({ className, name, link, image, hasNewPosts, color }: CoverCtaProps) => {
	return (
		hasNewPosts
			? <Badge.Ribbon className={`corner-wedge-badge`} text="NEW" placement="start" color="yellow">
				{cta({ className, name, link, image, color })}
			</Badge.Ribbon>
			:
			cta({ className, name, link, image, color })
	);
};

BgCoverCta.defaultProps = defaultProps;

export default BgCoverCta;
